
import ApexCharts, { ApexOptions } from 'apexcharts'
import React, { useEffect, useMemo, useRef } from 'react'
import { getCSS } from '../../../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../../../_metronic/partials'
import { TrendCategory, TrendGender } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useGetTrendGender } from '../../core/_query'
import { BarChartOnly } from '@/_metronic/partials/content/chart/BarChartOnly'

const TrendGenderAnalysisPieChart = () => {

  const { state } = useQueryRequest()
  const { data: trendGender, isLoading } = useGetTrendGender(state)

  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const data = useMemo(() => {
    return trendGender?.response?.data!
  }, [trendGender])

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data])

  return (
    <div className={`card shadow-wit mb-10`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3'>Gender</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        <div className='row'>
          {/* begin::Chart */}
          <div className='col-6'>
            <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '320px' }}></div>
          </div>
          <div className='col-6'>
            <BarChartOnly
              className='area-wib shadow-wit'
              color='primary'
              title='Revenue'
              data={data?.map((x) => ({
                gender: x.gender,
                total_sales: x.total_sales,
              }))}
              headers={['Gender', 'Total Sales']}
              formatCurrency={['total_sales']}
              series={[
                {
                  name: 'Gender',
                  data: data?.map((item) => item.total_sales),
                },
              ]}
              categories={data?.map((item) =>
                item.gender
              )}
              //   total={data?.summary_trend?.sales}
              layout='horizontal'
              isLoading={isLoading}
            />
          </div>
          {/* end::Chart */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}


export { TrendGenderAnalysisPieChart }

function getChartOptions(height: number, data: TrendGender[] | undefined): ApexOptions {
  let arrayOfSeries: any = []
  let arrayOfLabels: any = []
  if (data !== undefined) {
    arrayOfSeries = data?.map((obj) => (obj.total_qty !== null ? obj.total_qty : 0))
    arrayOfLabels = data?.map((obj) =>
      obj.gender !== null ? obj.gender : 'undefined'
    )
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
  }

  return {
    series: arrayOfSeries,
    chart: {
      width: 380,
      type: 'pie',
    },
    labels: arrayOfLabels,
    legend: {
      position: 'top',
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return numberWithCommas(val)
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          // chart: {
          //   width: 200,
          // },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  }
}
